module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidenav"
  }, [(_vm.user.company.status) ? _c('div', [_c('router-link', {
    staticClass: "success",
    attrs: {
      "to": {
        name: 'clients_add',
        params: {
          statusId: 1,
          modalVideo: true
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus"
  }), _vm._v(" Novo cadastro")]), _vm._v(" "), (_vm.isCompanyAdmin() || _vm.isCompanyFinancial()) ? [_c('router-link', {
    staticClass: "info",
    attrs: {
      "to": {
        name: 'finances_dashboard',
        query: {
          buy_credit: 1
        }
      }
    }
  }, [_vm._v("Comprar crédito")])] : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-home"
  }), _vm._v("Home")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'clients_list'
      }
    }
  }, [_vm._v("Cadastros")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'products_list'
      }
    }
  }, [_vm._v("Produtos")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'orders_list'
      }
    }
  }, [_vm._v("Pedidos")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'shopping_catalog'
      }
    }
  }, [_vm._v("Shopping")]), _vm._v(" "), (_vm.isCompanyAdmin() || _vm.isCompanyFinancial()) ? [_c('router-link', {
    attrs: {
      "to": {
        name: 'company_details'
      }
    }
  }, [_vm._v("Locadora")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'employees'
      }
    }
  }, [_vm._v("Usuários")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'finances_dashboard'
      }
    }
  }, [_vm._v("Financeiro")])] : _vm._e(), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.handleLogout()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sign-out"
  }), _vm._v(" Sair")])], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-17481c2a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/partials/PartialDrawerNavigation.vue
// module id = 962
// module chunks = 34